import { lazy, Suspense } from 'react'
import { cn } from '@joyful/utils'
import type { MarkdownProps } from './MarkdownImpl'
import { markdownVariants } from './markdownVariants'
export { markdownVariants } from './markdownVariants'
export type { MarkdownProps } from './MarkdownImpl'

const LazyMarkdown = lazy(async () => {
  const m = await import('./MarkdownImpl')
  return { default: m.Markdown }
})

function getMarkdownText(markdown: unknown): string {
  return typeof markdown === 'string' ? markdown : ''
}

function MarkdownTextFallback({
  children,
  inset,
  isBusy = false,
  leading,
  size,
  tone,
}: Pick<MarkdownProps, 'children' | 'inset' | 'leading' | 'size' | 'tone'> & {
  isBusy?: boolean
}) {
  const classNames = markdownVariants({ inset, leading, size, tone })

  return (
    <div
      aria-busy={isBusy}
      className={cn(
        classNames.root(),
        classNames.p(),
        'mb-0 whitespace-pre-wrap',
        isBusy ? 'animate-pulse' : undefined,
      )}
    >
      {children}
    </div>
  )
}

function Markdown(props: MarkdownProps) {
  const markdown = getMarkdownText(props.children)

  return (
    <Suspense
      fallback={
        <MarkdownTextFallback
          inset={props.inset}
          isBusy
          leading={props.leading}
          size={props.size}
          tone={props.tone}
        >
          {markdown}
        </MarkdownTextFallback>
      }
    >
      <LazyMarkdown {...props}>{markdown}</LazyMarkdown>
    </Suspense>
  )
}

export { Markdown }
